export const ORG_ID = 1 as const;

export const HTO_RETURN_WINDOW_IN_HOURS: number = 72 as const;
